// =============================================================================
// MeuDriver — useAdminFeaturedInstructors (Batch V3)
// Hook para toggle de instrutor em destaque (admin).
// =============================================================================

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { instructorKeys } from '@/hooks/useInstructors'

export interface ToggleFeaturedParams {
  id: string
  featured: boolean
}

export function useToggleFeatured() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, featured }: ToggleFeaturedParams) => {
      const { error } = await supabase.rpc('admin_toggle_featured_instructor', {
        p_instructor_id: id,
        p_featured: featured,
      } as Parameters<typeof supabase.rpc>[1])

      if (error) throw new Error(error.message)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: instructorKeys.all })
      queryClient.invalidateQueries({ queryKey: ['featured-instructors'] })
    },
  })
}
